module.exports = __webpack_public_path__ + "static/img/当心中毒.312006d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/当心中毒.png
// module id = 5iAu
// module chunks = 1